module.exports = "<div class=\"grid-container\">\n  <mat-card-title>Espacios</mat-card-title>\n</div>\n\n<app-spaces-list></app-spaces-list>\n"